import type {
  GeneratedStoryWithImageUrls,
  UpdateGeneratedStory,
} from 'schemas';
import { UpdateGeneratedStoryResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const updateGeneratedStory = async (
  storyId: string,
  data: UpdateGeneratedStory = {}
): Promise<{ message: string; story: GeneratedStoryWithImageUrls }> => {
  try {
    return await apiRequest(
      'PUT',
      `/api/generated-stories/${storyId}`,
      data,
      UpdateGeneratedStoryResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
